module.exports = __webpack_public_path__ + "static/media/preventivostickets-06-verde.4e8ab0b3.svg";